var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section",attrs:{"id":"contact-us"}},[_c('h1',{staticClass:"title is-4"},[_vm._v("お問い合わせ")]),_c('p',{staticClass:"block"},[_vm._v("Coming Soon")])])
}]

export { render, staticRenderFns }